import { React, useState } from 'react';
import styled from 'styled-components';
import { LoginForm } from './loginForm';
import { SignupForm } from './signupForm';
import { motion } from 'framer-motion';
import { AccountContext } from './accountContext';
import logopng from './../../logopng.png';

const BoxContainer = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  box-shadow: 0 0 2px rgba(15, 15, 15, 0.28);
  position: relative;
  overflow: hidden;
`;

const TopContainer = styled.div`
  width: 100%;
  height: 350px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 0 1.8em;
  padding-bottom: 15em;
`;

const BackDrop = styled(motion.div)`
  position: absolute;
  width: 160%;
  height: 570px;
  display: flex;
  flex-direction: column;
  border-radius: 50%;
  top: -290px;
  left: -70px;
  transform: rotate(60deg);
  background: linear-gradient(58deg, #5ecabe 20%, #075E54 100%);
`;

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const HeaderText = styled.div`
  font-size: 30px;
  font-weight: 600;
  line-height: 1.24;
  color: #fff;
  z-index: 10;
`;

const SmallText = styled.div`
  font-size: 11px;
  font-weight: 500;
  color: #fff;
  margin-top: 7px;
  z-index: 10;
`;

const InnerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px 20px;
`;

const backdropVariants = {
  expanded: {
    width: "233%",
    height: "1050px",
    borderRadius: "20%",
    transform: "rotate(60deg)"
  },
  collapsed: {
    width: "160%",
    height: "570px",
    borderRadius: "50%",
    transform: "rotate(60deg)"
  }
}

const expandingTransition = {
  type: "spring",
  duration: 2.3,
  stiffness: 30,
}

export default function AccountBox({props, setIsLoggedIn}) {
  const [isExpanded, setExpanded] = useState(false);
  const [active, setActive] = useState('signin');

  const playExpandingAnimation = () => {
    setExpanded(true);
    setTimeout(() => {
      setExpanded(false);
    }, expandingTransition.duration * 1000 - 1500);
  }

  const switchToSignup = () => {
    playExpandingAnimation();
    setTimeout(() => {
      setActive("signup");
    }, 400);
  }

  const switchToSignin = () => {
    playExpandingAnimation();
    setTimeout(() => {
      setActive("signin");
    }, 400);
  }

  const contextValue = {switchToSignup, switchToSignin};
  
  return (
  <AccountContext.Provider value={contextValue}>
  <BoxContainer>
    <TopContainer style={{zIndex:0}}>
      <img src={logopng} className='logopng'/>
      <BackDrop 
        initial={false}
        animate={isExpanded ? "expanded" : "collapsed"}
        variants={backdropVariants}
        transition={expandingTransition}
      />
      {active === "signin" && <HeaderContainer>
        <HeaderText>Welcome</HeaderText>
        <HeaderText>Back</HeaderText>
        <SmallText>Please sign-in to continue!</SmallText>
      </HeaderContainer>}
      {active === "signup" && <HeaderContainer>
        <HeaderText>Create</HeaderText>
        <HeaderText>Account</HeaderText>
        <SmallText>Please sign-up to continue!</SmallText>
      </HeaderContainer>}
    </TopContainer>
    <InnerContainer style={{zIndex: 100}}>
      {active === "signin" && <LoginForm setIsLoggedIn={setIsLoggedIn} />}
      {active === "signup" && <SignupForm />}
    </InnerContainer>
  </BoxContainer>
  </AccountContext.Provider>  
  );
}